import { Component } from '@angular/core';

@Component({
  selector: 'crtz-produto-detalhe-loader',
  templateUrl: './produto-detalhe-loader.component.html',
  styleUrls: ['./produto-detalhe-loader.component.scss']
})
export class ProdutoDetalheLoaderComponent { }
